<template>
    <div ref="windows">
        <Window
            v-for="(type, index) of Object.keys(windows)"
            :key="windows[type].id"
            :type="type"
            :title="getTitle(type)"
            :description="getDescription(type)"
            :width="getWindowWidth(type, index)"
            :z-index="getWindowZIndex(index, type)"
            :loading="getStatus(type)"
            :footer="getFooterEnabled(type)"
            :payload="getPayload(type)"
            @close="closeWindow"
            :window="windows[type]"
        />
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import Window from "./Window.vue";

export default {
    name: "WindowManager",
    components: {
        Window,
    },
    computed: {
        ...mapState({
            windows: (state) => state.app.windows,
        }),
    },
    methods: {
        ...mapActions({
            setWindows: "app/setWindows",
        }),
        closeWindow(type) {
            const windows = Object.keys(this.windows).reduce((acc, windowType) => {
                if (windowType !== type) {
                    acc[windowType] = this.windows[windowType];
                }
                return acc;
            }, {});
            this.setWindows(windows);
        },
        getTitle(type) {
            if (this.windows[type] && this.windows[type].title) {
                return this.windows[type].title;
            } else if (this.windows[type].type === "create-task") {
                return this.$t("task.createTask");
            } else if (this.windows[type].type === "edit-task") {
                return this.$t("task.editTask");
            } else if (this.windows[type].type === "show-visitor") {
                return this.$t("task.visitor");
            } else if (this.windows[type].type === "create-workflow") {
                return this.$t("task.createWorkflow");
            } else if (this.windows[type].type === "task-settings") {
                return this.$t("task.taskModuleSettingsTitle");
            } else if (this.windows[type].type === "edit-workflow") {
                return this.$t("task.editWorkflow");
            } else if (this.windows[type].type === "visibility-workflow") {
                return "Görünürlük";
            } else {
                return "";
            }
        },
        getDescription(type) {
            return this.windows[type].description;
        },
        getWindowWidth(type, index) {
            let width = `calc(80vw - ${index * 100}px)`;
            if (this.windows[type].size == "small") {
                width = "30vw";
            } else if (this.windows[type].size) {
                width = this.windows[type].size;
            }
            return width;
        },
        getStatus(type) {
            return this.windows[type].loadding || false;
        },
        getFooterEnabled(type) {
            return this.windows[type].footer;
        },
        getWindowZIndex(index, type) {
            const window = this.windows[type];

            return 1000 + index + 1;
        },
        getPayload(type) {
            return this.windows[type].payload;
        },
    },
};
</script>
